import "./MoveItemModal.scss";
import "../../../../components/ModalContent/ModalComponents.scss";
import { withAlpha } from "../../../../utils/colors";
import { useTranslation } from "react-i18next";

// Spacers only separate items - don't count them
const countItems = (list) =>
  (list.items || []).filter((item) => !item.isSpacer).length;

/**
 * Pick where to move a list item: another list (added to its top), or a
 * spacer in this or another list (added to that spacer's section).
 * Calls onMove(targetList, spacer) - spacer is null when a list is picked.
 */
function MoveItemModal({ item, currentList, lists, onMove, onCancel }) {
  const { t } = useTranslation();
  const otherLists = lists.filter((list) => list._id !== currentList._id);

  // Spacers the item can be moved under (a spacer itself can't be moved into
  // another spacer's section)
  const getSpacers = (list) =>
    item.isSpacer ? [] : (list.items || []).filter((i) => i.isSpacer);

  const currentSpacers = getSpacers(currentList);

  const renderSpacerChips = (list, spacers) => (
    <div className="move-item-spacers">
      {spacers.map((spacer) => {
        const spacerColor = spacer.color || list.color;
        return (
          <button
            key={spacer._id}
            className="move-item-spacer-chip"
            onClick={() => onMove(list, spacer)}
            title={t("lists.modals.moveItem.moveToSpacer", {
              spacer: spacer.text,
              list: list.title,
            })}
            style={{
              borderLeftColor: withAlpha(spacerColor, 1),
              backgroundColor: withAlpha(spacerColor, 0.1),
            }}
          >
            {spacer.text}
          </button>
        );
      })}
    </div>
  );

  return (
    <div className="move-item-modal-content">
      <div className="modal-title">
        <div>{t("lists.modals.moveItem.title", { name: item.text })}</div>
      </div>

      {otherLists.length === 0 && currentSpacers.length === 0 ? (
        <div className="move-item-empty">
          {t("lists.modals.moveItem.empty")}
        </div>
      ) : (
        <div className="move-item-targets">
          {currentSpacers.length > 0 && (
            <>
              <div className="move-item-section-title">
                {t("lists.withinThisList")}
              </div>
              {renderSpacerChips(currentList, currentSpacers)}
            </>
          )}
          {otherLists.length > 0 && (
            <div className="move-item-section-title">
              {t("lists.otherLists")}
            </div>
          )}
          {otherLists.map((list) => {
            const spacers = getSpacers(list);
            return (
              <div key={list._id} className="move-item-list-group">
                <button
                  className="move-item-list-card"
                  onClick={() => onMove(list, null)}
                  style={{ borderLeftColor: withAlpha(list.color, 1) }}
                >
                  <span className="move-item-list-title">{list.title}</span>
                  <span className="move-item-list-count">
                    {t("lists.itemCount", { count: countItems(list) })}
                  </span>
                </button>
                {spacers.length > 0 && renderSpacerChips(list, spacers)}
              </div>
            );
          })}
        </div>
      )}

      <div className="modal-form-buttons">
        <button className="modal-button cancel" onClick={onCancel}>
          {t("common.cancel")}
        </button>
      </div>
    </div>
  );
}

export default MoveItemModal;
